const APP_ORIGIN_KEY = 'appOrigin';

/**
 * Captures the appOrigin query parameter from the current URL and stores it
 * in localStorage. Should be called once on app load.
 *
 * When QuestionPro redirects a user to Reputation it appends
 * ?appOrigin=https://eu.questionpro.com (or whichever environment the user
 * came from). We persist this so that all subsequent redirects back to QP
 * (login, logout, product-switcher) use the correct environment URL instead
 * of the hardcoded production domain.
 */
export function captureAppOrigin(): void {
  const params = new URLSearchParams(window.location.search);
  const origin = params.get('appOrigin');
  if (origin) {
    localStorage.setItem(APP_ORIGIN_KEY, origin);
  }
}

/**
 * Returns the stored appOrigin URL, falling back to the REACT_APP_QP_DOMAIN
 * environment variable if no appOrigin was captured.
 */
export function getQpDomain(): string {
  return localStorage.getItem(APP_ORIGIN_KEY)
    || process.env.REACT_APP_QP_DOMAIN
    || process.env.REACT_APP_QP_API_URL
    || '';
}
